jQuery(document).ready(function($) {
    const $blocks = $('.wp-block-jormi-blocks-query-card');
    const $triggers = $blocks.find('[data-hs-overlay]');
    
    $triggers.on('click', function(e) {
        e.preventDefault();
        
        const overlayId = $(this).data('hs-overlay');
        
        // Set overflow hidden on html element
        $('html').css('overflowY', 'hidden');
        
        // Listen for click on close button and overlay background to restore scroll
        const $overlay = $(overlayId);
        const $closeButton = $overlay.find('button[data-hs-overlay]');
        $closeButton.one('click', function() {
            $('html').css('overflowY', 'auto');
        });
        
        // Listen for click on overlay to restore scroll (clicks on children is not considered a close event)
        $overlay.on('click', function(e) {
            if (e.target === this) {
                $('html').css('overflowY', 'auto');
                // Remove this event listener after it's triggered
                $(this).off('click');
            }
        });
    });
    
    // Handle Escape key to close overlay and restore scroll
    $(document).on('keyup', function(e) {
        if (e.key === 'Escape') {
            $('html').css('overflowY', 'auto');
        }
    });

    // Content Grid - Accordion Style

    var $cell = $('.acc-item');

    //open and close card when clicked on card
    $cell.find('.js-expander').click(function () {

        var $thisCell = $(this).closest('.acc-item');

        if ($thisCell.hasClass('is-collapsed')) {
            $cell.not($thisCell).removeClass('is-expanded').addClass('is-collapsed').addClass('is-inactive');
            $thisCell.removeClass('is-collapsed').addClass('is-expanded');

            if ($cell.not($thisCell).hasClass('is-inactive')) {
                //do nothing
            } else {
                $cell.not($thisCell).addClass('is-inactive');
            }

        } else {
            $thisCell.removeClass('is-expanded').addClass('is-collapsed');
            $cell.not($thisCell).removeClass('is-inactive');
        }
    });

    //close card when click on cross
    $cell.find('.js-collapser').click(function () {

        var $thisCell = $(this).closest('.acc-item');

        $thisCell.removeClass('is-expanded').addClass('is-collapsed');
        $cell.not($thisCell).removeClass('is-inactive');

    });
});